import { Application, ChannelTypes, Dealer } from '../../gql/graphql';
import { Role } from '../../types/role';
import { AppConfig } from '../../app.config';

export type conditions = {
  isVirtualCard?: boolean;
  channelType?: ChannelTypes;
  role?: Role | null;
};

// TODO rename
export const shouldProcessNeuroId = (dealer: Dealer, role: Role, isNeuroIdEnabled: boolean): boolean => {
  const isBrickAndMortar = dealer?.channelType === ChannelTypes.BrickAndMortar;
  const isCustomerRole = role === Role.Customer;
  const isChannelTypeAppropriate = dealer.isVirtualCard || isBrickAndMortar;
  return isCustomerRole && isChannelTypeAppropriate && isNeuroIdEnabled;
};

type NeuroIdInitContext = {
  shouldProcessNeuroId: boolean;
  dealer: Dealer;
  orderId: string;
  application?: Application;
};

export const initializeNeuroIdFromContext = (ctx: NeuroIdInitContext): void => {
  if (!ctx.shouldProcessNeuroId) return;
  initializeNeuroIdSession(AppConfig.env !== 'prod');
  nid('setVariable', 'dealerId', ctx.dealer.id?.toString());
  nid('identify', ctx.application?.lease?.neuroIdIdentityId || ctx.orderId);
  if (ctx.application?.customer?.id) {
    nid('setRegisteredUserId', ctx.application.customer.id.toString());
  }
};

export const initializeNeuroIdSession = (isLLE: boolean) => {
  const script = document.createElement('script');

  const testENV = isLLE ? '-test' : '';

  script.innerHTML = `
    (function(n,e,u,r,o,i,d){
        n.nid=n.nid||function(){(n.nid.q=n.nid.q||[]).push(arguments)};
        o=e.createElement(u);i=e.getElementsByTagName(u)[0];o.async=1;
        o.src=r;i.parentNode.insertBefore(o,i);
    })(window,document,'script','//scripts.neuro-id.com/c/nid-atoms475${testENV}.js');
  `;
  document.head.appendChild(script);

  nid('start', { linkedSiteId: 'form_anvil047' });
};
